import { render, staticRenderFns } from "./AudioEffectCmd.vue?vue&type=template&id=5356a5f4"
import script from "./AudioEffectCmd.vue?vue&type=script&lang=js"
export * from "./AudioEffectCmd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports